import LineGradient from "../components/LineGradient"
import { motion } from "framer-motion"

const container ={
    hidden: {},
    visible:{
        transition : {staggerChildren: 0.2}
    }
}

const projectVariant = {
    hidden: {opacity: 0,scale: 0.8},
    visible: {opacity:1,scale:1}
}


const Projects = () => {
  return (
    <section id="projects" className="pt-48 pb-48">
        {/* headings */}
        <motion.div
            className="md:w-2/4 mx-auto text-center"
            initial="hidden"
            whileInView="visible"
            viewport={{once:true,amount:0.5}}
            transition={{duration:0.5}}
            variants={{
                hidden: {opacity:0,y: -50},
                visible: {opacity:1,y:0}
            }}
        >
            <div className="">
            <p className="font-playfair font-semibold text-4xl">
                <span className="text-[#929AAB]">PRO</span>JECTS
            </p>
            <div className="flex justify-center mt-5">
                <LineGradient width="w-1/3" />
            </div>
            </div>

            <p className="mt-10 mb-10">
                Developed user-friendly interfaces, optimized UX/UI designs, implemented responsive web solutions, and ensured cross-browser compatibility for diverse projects.
            </p>
        </motion.div>

        {/* projects */}
        <div className="flex justify-center">
            <motion.div
                className="sm:grid sm:grid-cols-3"
                initial="hidden"
                whileInView="visible"
                viewport={{once:true,amount:0.5}}
                transition={{duration:0.5}}
                variants={container}
            >
            <div className="flex justify-center text-center items-center p-10 bg-[#393E46] text-white max-w-[400px] max-h-[400px] text-2xl font-playfair font font-semibold">
                BEAUTIFUL USER INTERFACES
            </div>  
            <div   className="relative flex justify-center items-center p-10 max-w-[400px] max-h-[400px]">
                <div className={`absolute h-full w-full opacity-0 hover:opacity-90 transition duration-500 bg-grey z-30 flex flex-col justify-center items-center text-center p-16 text-deep-blue`}>
                    <p className="text-2xl font-playfair">{"Project 1"}</p>
                    <a 
                        className='text-2xl text-cyan-800 hover:opacity-50 transition duration-500'
                        href={`https://gym-kw-site.netlify.app/`}
                        target='_blank'
                        rel='noreferrer'
                    >
                        Live Demo
                    </a>
                    <a 
                        className='text-2xl text-cyan-800 hover:opacity-50 transition duration-500'
                        href={`https://github.com/KanchanaSW/exercise-site/tree/master`}
                        target='_blank'
                        rel='noreferrer'
                    >
                        Repo
                    </a>
                </div>
                <img src={`../assets/${"project-1"}.jpeg`} alt={"Project 1"} />
             </div>
            <div   className="relative flex justify-center items-center p-10 max-w-[400px] max-h-[400px]">
                <div className={`absolute h-full w-full opacity-0 hover:opacity-90 transition duration-500 bg-grey z-30 flex flex-col justify-center items-center text-center p-16 text-deep-blue`}>
                    <p className="text-2xl font-playfair">{"Project 2"}</p>
                    <a 
                        className='text-2xl text-cyan-800 hover:opacity-50 transition duration-500'
                        href={`https://article-summarizer-kw.netlify.app/`}
                        target='_blank'
                        rel='noreferrer'
                    >
                        Live Demo
                    </a>
                    <a 
                        className='text-2xl text-cyan-800 hover:opacity-50 transition duration-500'
                        href={`https://github.com/KanchanaSW/summarizer-ai`}
                        target='_blank'
                        rel='noreferrer'
                    >
                        Repo
                    </a>
                </div>
                <img src={`../assets/${"project-2"}.jpeg`} alt={"Project 2"} />
             </div>
    {/* row 2 */}
            <div   className="relative flex justify-center items-center p-10 max-w-[400px] max-h-[400px]">
                <div className={`absolute h-full w-full opacity-0 hover:opacity-90 transition duration-500 bg-grey z-30 flex flex-col justify-center items-center text-center p-16 text-deep-blue`}>
                    <p className="text-2xl font-playfair">{"Project 3"}</p>
                    <a 
                        className='text-2xl text-cyan-800 hover:opacity-50 transition duration-500'
                        href={`https://shoe-site-kw.netlify.app/`}
                        target='_blank'
                        rel='noreferrer'
                    >
                        Live Demo
                    </a>
                    <a 
                        className='text-2xl text-cyan-800 hover:opacity-50 transition duration-500'
                        href={`https://github.com/KanchanaSW/nike`}
                        target='_blank'
                        rel='noreferrer'
                    >
                        Repo
                    </a>
                </div>
                <img src={`../assets/${"project-3"}.jpeg`} alt={"Project 3"} />
             </div>
            <div   className="relative flex justify-center items-center p-10 max-w-[400px] max-h-[400px]">
                <div className={`absolute h-full w-full opacity-0 hover:opacity-90 transition duration-500 bg-grey z-30 flex flex-col justify-center items-center text-center p-16 text-deep-blue`}>
                    <p className="text-2xl font-playfair">{"Project 4"}</p>
                    <a 
                        className='text-2xl text-cyan-800 hover:opacity-50 transition duration-500'
                        href={`https://jane-esper-portfolio-site.netlify.app/`}
                        target='_blank'
                        rel='noreferrer'
                    >
                        Live Demo
                    </a>
                    <a 
                        className='text-2xl text-cyan-800 hover:opacity-50 transition duration-500'
                        href={`https://github.com/KanchanaSW/portfolio-site-JE`}
                        target='_blank'
                        rel='noreferrer'
                    >
                        Repo
                    </a>
                </div>
                <img src={`../assets/${"project-4"}.jpeg`} alt={"Project 4"} />
             </div>
             <div   className="relative flex justify-center items-center p-10 max-w-[400px] max-h-[400px]">
                <div className={`absolute h-full w-full opacity-0 hover:opacity-90 transition duration-500 bg-grey z-30 flex flex-col justify-center items-center text-center p-16 text-deep-blue`}>
                    <p className="text-2xl font-playfair">{"Project 5"}</p>
                    <a 
                        className='text-2xl text-cyan-800 hover:opacity-50 transition duration-500'
                        href={`https://musing-swartz-f036bd.netlify.app/`}
                        target='_blank'
                        rel='noreferrer'
                    >
                        Live Demo
                    </a>
                    <a 
                        className='text-2xl text-cyan-800 hover:opacity-50 transition duration-500'
                        href={`https://github.com/KanchanaSW/fire-todo`}
                        target='_blank'
                        rel='noreferrer'
                    >
                        Repo
                    </a>
                </div>
                <img src={`../assets/${"project-5"}.jpeg`} alt={"Project 5"} />
             </div>
{/* row 3 */}
            <div   className="relative flex justify-center items-center p-10 max-w-[400px] max-h-[400px]">
                <div className={`absolute h-full w-full opacity-0 hover:opacity-90 transition duration-500 bg-grey z-30 flex flex-col justify-center items-center text-center p-16 text-deep-blue`}>
                    <p className="text-2xl font-playfair">{"Project 6"}</p>
                    <a 
                        className='text-2xl text-cyan-800 hover:opacity-50 transition duration-500'
                        href={`https://cute-gingersnap-71f20a.netlify.app/`}
                        target='_blank'
                        rel='noreferrer'
                    >
                        Live Demo
                    </a>
                    <a 
                        className='text-2xl text-cyan-800 hover:opacity-50 transition duration-500'
                        href={`https://github.com/KanchanaSW/react-website-v2`}
                        target='_blank'
                        rel='noreferrer'
                    >
                        Repo
                    </a>
                </div>
                <img src={`../assets/${"project-6"}.jpeg`} alt={"Project 6"} />
             </div>
            <div   className="relative flex justify-center items-center p-10 max-w-[400px] max-h-[400px]">
                <div className={`absolute h-full w-full opacity-0 hover:opacity-90 transition duration-500 bg-grey z-30 flex flex-col justify-center items-center text-center p-16 text-deep-blue`}>
                    <p className="text-2xl font-playfair">{"Project 7"}</p>
                    <a 
                        className='text-2xl text-cyan-800 hover:opacity-50 transition duration-500'
                        href={`https://celebrated-sunshine-0259f3.netlify.app/`}
                        target='_blank'
                        rel='noreferrer'
                    >
                        Live Demo
                    </a>
                    <a 
                        className='text-2xl text-cyan-800 hover:opacity-50 transition duration-500'
                        href={`https://github.com/KanchanaSW/react-website-v1`}
                        target='_blank'
                        rel='noreferrer'
                    >
                        Repo
                    </a>
                </div>
                <img src={`../assets/${"project-7"}.jpeg`} alt={"Project 7"} />
             </div>
            <div className="flex justify-center text-center items-center p-10 bg-[#929AAB] max-w-[400px] max-h-[400px] text-2xl font-playfair font font-semibold">
                SMOOTH USER EXPERIENCE
            </div>

            </motion.div>
        </div>

    </section>
  )
}

export default Projects